import store from '@/store';
import { bindAll, get } from 'lodash';

function getters() {
	return store.getters || store.default.getters;
}

var Policies = {
	SupportTech: function() {
		return this.InternalSupportTech() || this.ExternalSupportTech();
	},
	InternalSupportTech: function() {
		return get(getters(), 'oidcStore/oidcUser.SupportTech', false);
	},
	ExternalSupportTech: function() {
		return get(getters(), 'oidcStore/oidcUser.ExternalSupportTech', false);
	}
};

bindAll(Policies, Object.keys(Policies));

export default Policies;
